import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import ecoUi from 'common-ui'
import i18n from '@/locale/index.js'
import moment from 'moment' //日期格式化插件
import '@/assets/icon/iconfont.css'

import 'common-ui/lib/common-ui.css'
import '@/assets/css/element-custom.scss'
import '@/directive.js'
import FeSubmitButton from '@/components/common/FeSubmitButton.vue'
import FeDeleteButton from '@/components/common/FeDeleteButton.vue'
import FeLoadData from '@/components/common/FeLoadData.vue'
import contractPrint from '@/views/form/contractPrint.vue'
import signTemplate from '@/views/form/signTemplate.vue'
import VueUeditorWrap from 'vue-ueditor-wrap' //引入富文本组件
// import VueUeditorWrap from "@/components/vueUeditorWrap/vue-ueditor-wrap.vue"; //引入富文本组件
import VueCodeMirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-light.css'
import 'codemirror/mode/vue/vue'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/groovy/groovy'
import req from '@/request.js'
import 'jquery'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import deepmerge from 'deepmerge'
import validate from '@/validate.js'
import dict from '@/locale/validate/dict.js'
import VueAMap from 'vue-amap' //高德地图插件
import VueClipboard from 'vue-clipboard2' //复制内容到剪贴板
import FeTable from '@/components/common/FeTable.vue'
import FeTableColumn from '@/components/common/FeTableColumn.vue'
import FeTableSearchField from '@/components/common/FeTableSearchField.vue'
import FeTableSearchPanel from '@/components/common/FeTableSearchPanel.vue'
import FeFieldTail from '@/components/common/FeFieldTail.vue'
import FeFile from '@/components/common/FeFile.vue'
import EipAttachment from '@/components/eipControl/EipAttachment.vue'
import vueTinymceWrap from '@/components/vueTinymceWrap/vue-tinymce-wrap.vue'
import utils from './utils'
import '@/assets/icon/iconfont.js'

Vue.config.productionTip = false
Vue.prototype.$http = req
Vue.prototype.$utils = utils

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
  size: 'small'
})
Vue.use(ecoUi)
Vue.use(VXETable)
// , {
//     i18n: (key, value) => i18n.t(key, value)
// });
//使用vue-codemirror组件
Vue.use(VueCodeMirror)
Vue.use(VueAMap)
Vue.use(VueClipboard)
// 注册全局组件
Vue.component('contractPrint', contractPrint)
Vue.component('signTemplate', signTemplate)
Vue.component('FeSubmitButton', FeSubmitButton)
Vue.component('FeDeleteButton', FeDeleteButton)
Vue.component('FeLoadData', FeLoadData)
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.component('FeTable', FeTable)
Vue.component('FeTableColumn', FeTableColumn)
Vue.component('FeTableSearchField', FeTableSearchField)
Vue.component('FeTableSearchPanel', FeTableSearchPanel)
Vue.component('FeFieldTail', FeFieldTail)
Vue.component('FeFile', FeFile)
Vue.component('EipAttachment', EipAttachment)
Vue.component('VueTinymceWrap', vueTinymceWrap)

let app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')

export default app

let validateLocal = localStorage.getItem('lang')
let currentLocal = validateLocal || 'zh-CN'
app && app.$validator && app.$validator.localize(currentLocal)
Vue.filter('dateYMDFormat', function (dateStr, pattern = 'YYYY-MM-DD') {
  if (dateStr) {
    return moment(dateStr).format(pattern)
  } else {
    return ''
  }
})
if (app.$validator) {
  for (let rule in validate) {
    app.$validator.rules[rule] = validate[rule]
  }
  app.$validator.dictionary.container = deepmerge(dict, app.$validator.dictionary.container, { clone: true })
}
